export const Countries = {
  af: "Afghanistan",
  al: "Albania",
  dz: "Algeria",
  as: "American Samoa",
  ad: "Andorra",
  ao: "Angola",
  ai: "Anguilla",
  aq: "Antarctica",
  ag: "Antigua and Barbuda",
  ar: "Argentina",
  am: "Armenia",
  aw: "Aruba",
  au: "Australia",
  at: "Austria",
  az: "Azerbaijan",
  bs: "Bahamas",
  bh: "Bahrain",
  bd: "Bangladesh",
  bb: "Barbados",
  by: "Belarus",
  be: "Belgium",
  bz: "Belize",
  bj: "Benin",
  bm: "Bermuda",
  bt: "Bhutan",
  bo: "Bolivia",
  ba: "Bosnia and herzegovina",
  bw: "Botswana",
  bv: "Bouvet island",
  br: "Brazil",
  io: "British Indian Ocean Territory",
  bn: "Brunei Darussalam",
  bg: "Bulgaria",
  bf: "Burkina Faso",
  bi: "Burundi",
  kh: "Cambodia",
  cm: "Cameroon",
  ca: "Canada",
  cv: "Cape Verde",
  ky: "Cayman Islands",
  cf: "Central African Republic",
  td: "Chad",
  cl: "Chile",
  cn: "China",
  cx: "Christmas Island",
  cc: "Cocos (Keeling) Islands",
  co: "Colombia",
  km: "Comoros",
  cg: "Congo",
  cd: "Democratic Republic of the Congo",
  ck: "Cook Islands",
  cr: "Costa Rica",
  ci: "Cote d Ivoire",
  hr: "Croatia",
  cu: "Cuba",
  cy: "Cyprus",
  cz: "Czech Republic",
  dk: "Denmark",
  dj: "Djibouti",
  dm: "Dominica",
  do: "Dominican Republic",
  tp: "East Timor",
  ec: "Ecuador",
  eg: "Egypt",
  sv: "El Salvador",
  gq: "Equatorial Guinea",
  er: "Eritrea",
  ee: "Estonia",
  et: "Ethiopia",
  fk: "Falkland Islands (Malvinas)",
  fo: "Faroe Islands",
  fj: "Fiji",
  fi: "Finland",
  fr: "France",
  gf: "French Guiana",
  pf: "French Polynesia",
  tf: "French Southern Territories",
  ga: "Gabon",
  gm: "Gambia",
  ge: "Georgia",
  de: "Germany",
  gh: "Ghana",
  gi: "Gibraltar",
  gr: "Greece",
  gl: "Greenland",
  gd: "Grenada",
  gp: "Guadeloupe",
  gu: "Guam",
  gt: "Guatemala",
  gn: "Guinea",
  gw: "Guinea-bissau",
  gy: "Guyana",
  ht: "Haiti",
  hm: "Heard Island and Mcdonald Islands",
  va: "Holy See (Vatican City State)",
  hn: "Honduras",
  hk: "Hong Kong",
  hu: "Hungary",
  is: "Iceland",
  in: "India",
  id: "Indonesia",
  ir: "Iran, Islamic Republic of",
  iq: "Iraq",
  ie: "Ireland",
  il: "Israel",
  it: "Italy",
  jm: "Jamaica",
  jp: "Japan",
  jo: "Jordan",
  kz: "Kazakstan",
  ke: "Kenya",
  ki: "Kiribati",
  kp: "Korea Democratic Peoples Republic of",
  kr: "Korea Republic of",
  kw: "Kuwait",
  kg: "Kyrgyzstan",
  la: "Lao Peoples Democratic Republic",
  lv: "Latvia",
  lb: "Lebanon",
  ls: "Lesotho",
  lr: "Liberia",
  ly: "Libyan Arab Jamahiriya",
  li: "Liechtenstein",
  lt: "Lithuania",
  lu: "Luxembourg",
  mo: "Macau",
  mk: "Macedonia, the former yugoslav republic of",
  mg: "Madagascar",
  mw: "Malawi",
  my: "Malaysia",
  mv: "Maldives",
  ml: "Mali",
  mt: "Malta",
  mh: "Marshall Islands",
  mq: "Martinique",
  mr: "Mauritania",
  mu: "Mauritius",
  yt: "Mayotte",
  mx: "Mexico",
  fm: "Micronesia, Federated States of",
  md: "Moldova, Republic of",
  mc: "Monaco",
  mn: "Mongolia",
  ms: "Montserrat",
  ma: "Morocco",
  mz: "Mozambique",
  mm: "Myanmar",
  na: "Namibia",
  nr: "Nauru",
  np: "Nepal",
  nl: "Netherlands",
  an: "Netherlands Antilles",
  nc: "New Caledonia",
  nz: "New Zealand",
  ni: "Nicaragua",
  ne: "Niger",
  ng: "Nigeria",
  nu: "Niue",
  nf: "Norfolk Island",
  mp: "Northern Mariana Islands",
  no: "Norway",
  om: "Oman",
  pk: "Pakistan",
  pw: "Palau",
  ps: "Palestinian territory, occupied",
  pa: "Panama",
  pg: "Papua New Guinea",
  py: "Paraguay",
  pe: "Peru",
  ph: "Philippines",
  pn: "Pitcairn",
  pl: "Poland",
  pt: "Portugal",
  pr: "Puerto Rico",
  qa: "Qatar",
  re: "Reunion",
  ro: "Romania",
  ru: "Russian Federation",
  rw: "Rwanda",
  sh: "Saint Helena",
  kn: "Saint Kitts and Nevis",
  lc: "Saint Lucia",
  pm: "Saint Pierre and Miquelon",
  vc: "Saint Vincent and the Grenadines",
  ws: "Samoa",
  sm: "San Marino",
  st: "Sao Tome and Principe",
  sa: "Saudi Arabia",
  sn: "Senegal",
  rs: "Serbia",
  sc: "Seychelles",
  sl: "Sierra Leone",
  sg: "Singapore",
  sk: "Slovakia",
  si: "Slovenia",
  sb: "Solomon Islands",
  so: "Somalia",
  za: "South Africa",
  gs: "South Georgia and the South Sandwich Islands",
  es: "Spain",
  lk: "Sri lanka",
  sd: "Sudan",
  sr: "Suriname",
  sj: "Svalbard and Jan Mayen",
  sz: "Swaziland",
  se: "Sweden",
  ch: "Switzerland",
  sy: "Syrian Arab Republic",
  tw: "Taiwan, Province of China",
  tj: "Tajikistan",
  tz: "Tanzania, United Republic of",
  th: "Thailand",
  tg: "Togo",
  tk: "Tokelau",
  to: "Tonga",
  tt: "Trinidad and Tobago",
  tn: "Tunisia",
  tr: "Turkey",
  tm: "Turkmenistan",
  tc: "Turks and Caicos Islands",
  tv: "Tuvalu",
  ug: "Uganda",
  ua: "Ukraine",
  ae: "United Arab Emirates",
  gb: "United Kingdom",
  us: "United States",
  um: "United States Minor Outlying Islands",
  uy: "Uruguay",
  uz: "Uzbekistan",
  vu: "Vanuatu",
  ve: "Venezuela",
  vn: "Viet Nam",
  vg: "Virgin Islands, British",
  vi: "Virgin Islands, U.S.",
  wf: "Wallis and Futuna",
  eh: "Western Sahara",
  ye: "Yemen",
  yu: "Yugoslavia",
  zm: "Zambia",
  zw: "Zimbabwe",
};

export const StatesPK = {
  Sindh: "Sindh",
  Punjab: "Punjab",
  Balochistan: "Balochistan",
  "Khyber pakhtunkhwa": "Khyber pakhtunkhwa",
};

export const StatesUSA = {
  Alabama: "Alabama",
  Alaska: "Alaska",
  Arizona: "Arizona",
  Arkansas: "Arkansas",
  California: "California",
  Colorado: "Colorado",
  Connecticut: "Connecticut",
  Delaware: "Delaware",
  Florida: "Florida",
  Georgia: "Georgia",
  Hawaii: "Hawaii",
  Idaho: "Idaho",
  Illinois: "Illinois",
  Indiana: "Indiana",
  Iowa: "Iowa",
  Kansas: "Kansas",
  Kentucky: "Kentucky",
  Louisiana: "Louisiana",
  Maine: "Maine",
  Maryland: "Maryland",
  Massachusetts: "Massachusetts",
  Michigan: "Michigan",
  Minnesota: "Minnesota",
  Mississippi: "Mississippi",
  Missouri: "Missouri",
  Montana: "Montana",
  Nebraska: "Nebraska",
  Nevada: "Nevada",
  "New hampshire": "New hampshire",
  "New jersey": "New jersey",
  "New mexico": "New mexico",
  "New york": "New york",
  "North carolina": "North carolina",
  "North dakota": "North dakota",
  Ohio: "Ohio",
  Oklahoma: "Oklahoma",
  Oregon: "Oregon",
  Pennsylvania: "Pennsylvania",
  "Rhode island": "Rhode island",
  "South carolina": "South carolina",
  "South dakota": "South dakota",
  Tennessee: "Tennessee",
  Texas: "Texas",
  Utah: "Utah",
  Vermont: "Vermont",
  Virginia: "Virginia",
  Washington: "Washington",
  "West virginia": "West virginia",
  Wisconsin: "Wisconsin",
  Wyoming: "Wyoming",
};

export const CountryPhoneCode = {
  bd: "+880",
  be: "+32",
  bf: "+226",
  bg: "+359",
  ba: "+387",
  bb: "+1-246",
  wf: "+681",
  bl: "+590",
  bm: "+1-441",
  bn: "+673",
  bo: "+591",
  bh: "+973",
  bi: "+257",
  bj: "+229",
  bt: "+975",
  jm: "+1-876",
  bv: "",
  bw: "+267",
  ws: "+685",
  bq: "+599",
  br: "+55",
  bs: "+1-242",
  je: "+44-1534",
  by: "+375",
  bz: "+501",
  ru: "+7",
  rw: "+250",
  rs: "+381",
  tl: "+670",
  re: "+262",
  tm: "+993",
  tj: "+992",
  ro: "+40",
  tk: "+690",
  gw: "+245",
  gu: "+1-671",
  gt: "+502",
  gs: "",
  gr: "+30",
  gq: "+240",
  gp: "+590",
  jp: "+81",
  gy: "+592",
  gg: "+44-1481",
  gf: "+594",
  ge: "+995",
  gd: "+1-473",
  gb: "+44",
  ga: "+241",
  sv: "+503",
  gn: "+224",
  gm: "+220",
  gl: "+299",
  gi: "+350",
  gh: "+233",
  om: "+968",
  tn: "+216",
  jo: "+962",
  hr: "+385",
  ht: "+509",
  hu: "+36",
  hk: "+852",
  hn: "+504",
  hm: "+ ",
  ve: "+58",
  pr: "+1-787 and 1-939",
  ps: "+970",
  pw: "+680",
  pt: "+351",
  sj: "+47",
  py: "+595",
  iq: "+964",
  pa: "+507",
  pf: "+689",
  pg: "+675",
  pe: "+51",
  pk: "+92",
  ph: "+63",
  pn: "+870",
  pl: "+48",
  pm: "+508",
  zm: "+260",
  eh: "+212",
  ee: "+372",
  eg: "+20",
  za: "+27",
  ec: "+593",
  it: "+39",
  vn: "+84",
  sb: "+677",
  et: "+251",
  so: "+252",
  zw: "+263",
  sa: "+966",
  es: "+34",
  er: "+291",
  me: "+382",
  md: "+373",
  mg: "+261",
  mf: "+590",
  ma: "+212",
  mc: "+377",
  uz: "+998",
  mm: "+95",
  ml: "+223",
  mo: "+853",
  mn: "+976",
  mh: "+692",
  mk: "+389",
  mu: "+230",
  mt: "+356",
  mw: "+265",
  mv: "+960",
  mq: "+596",
  mp: "+1-670",
  ms: "+1-664",
  mr: "+222",
  im: "+44-1624",
  ug: "+256",
  tz: "+255",
  my: "+60",
  mx: "+52",
  il: "+972",
  fr: "+33",
  io: "+246",
  sh: "+290",
  fi: "+358",
  fj: "+679",
  fk: "+500",
  fm: "+691",
  fo: "+298",
  ni: "+505",
  nl: "+31",
  no: "+47",
  na: "+264",
  vu: "+678",
  nc: "+687",
  ne: "+227",
  nf: "+672",
  ng: "+234",
  nz: "+64",
  np: "+977",
  nr: "+674",
  nu: "+683",
  ck: "+682",
  xk: "",
  ci: "+225",
  ch: "+41",
  co: "+57",
  cn: "+86",
  cm: "+237",
  cl: "+56",
  cc: "+61",
  ca: "+1",
  cg: "+242",
  cf: "+236",
  cd: "+243",
  cz: "+420",
  cy: "+357",
  cx: "+61",
  cr: "+506",
  cw: "+599",
  cv: "+238",
  cu: "+53",
  sz: "+268",
  sy: "+963",
  sx: "+599",
  kg: "+996",
  ke: "+254",
  ss: "+211",
  sr: "+597",
  ki: "+686",
  kh: "+855",
  kn: "+1-869",
  km: "+269",
  st: "+239",
  sk: "+421",
  kr: "+82",
  si: "+386",
  kp: "+850",
  kw: "+965",
  sn: "+221",
  sm: "+378",
  sl: "+232",
  sc: "+248",
  kz: "+7",
  ky: "+1-345",
  sg: "+65",
  se: "+46",
  sd: "+249",
  do: "+1-809 and 1-829",
  dm: "+1-767",
  dj: "+253",
  dk: "+45",
  vg: "+1-284",
  de: "+49",
  ye: "+967",
  dz: "+213",
  us: "+1",
  uy: "+598",
  yt: "+262",
  um: "+1",
  lb: "+961",
  lc: "+1-758",
  la: "+856",
  tv: "+688",
  tw: "+886",
  tt: "+1-868",
  tr: "+90",
  lk: "+94",
  li: "+423",
  lv: "+371",
  to: "+676",
  lt: "+370",
  lu: "+352",
  lr: "+231",
  ls: "+266",
  th: "+66",
  tf: "",
  tg: "+228",
  td: "+235",
  tc: "+1-649",
  ly: "+218",
  va: "+379",
  vc: "+1-784",
  ae: "+971",
  ad: "+376",
  ag: "+1-268",
  af: "+93",
  ai: "+1-264",
  vi: "+1-340",
  is: "+354",
  ir: "+98",
  am: "+374",
  al: "+355",
  ao: "+244",
  aq: "",
  as: "+1-684",
  ar: "+54",
  au: "+61",
  at: "+43",
  aw: "+297",
  in: "+91",
  ax: "+358-18",
  az: "+994",
  ie: "+353",
  id: "+62",
  ua: "+380",
  qa: "+974",
  mz: "+258",
};

export const TimeZone = {
  Kwajalein: "(GMT-12:00) International Date Line West",
  "Pacific/Midway": "(GMT-11:00) Midway Island",
  "Pacific/Samoa": "(GMT-11:00) Samoa",
  "Pacific/Honolulu": "(GMT-10:00) Hawaii",
  "America/Anchorage": "(GMT-09:00) Alaska",
  "America/Los_Angeles": "(GMT-08:00) Pacific Time (US &amp; Canada)",
  "America/Tijuana": "(GMT-08:00) Tijuana, Baja California",
  "America/Denver": "(GMT-07:00) Mountain Time (US &amp; Canada)",
  "America/Chihuahua": "(GMT-07:00) Chihuahua",
  "America/Mazatlan": "(GMT-07:00) Saskatchewan (No Daylight Saving)",
  "America/Regina": "(GMT-06:00) Saskatchewan",
  "America/Phoenix": "(GMT-07:00) Arizona (No Daylight Saving)",
  "America/Tegucigalpa": "(GMT-06:00) Central America",
  "America/Chicago": "(GMT-06:00) Central Time (US &amp; Canada)",
  "America/Mexico_City": "(GMT-06:00) Mexico City",
  "America/Monterrey": "(GMT-06:00) Monterrey",
  "America/New_York": "(GMT-05:00) Eastern Time (US &amp; Canada)",
  "America/Bogota": "(GMT-05:00) Bogota",
  "America/Lima": "(GMT-05:00) Lima",
  "America/Rio_Branco": "(GMT-05:00) Rio Branco",
  "America/Indiana/Indianapolis": "(GMT-05:00) Indiana (East)",
  "America/Caracas": "(GMT-04:00) Caracas",
  "America/Halifax": "(GMT-04:00) Atlantic Time (Canada)",
  "America/Manaus": "(GMT-04:00) Manaus",
  "America/Santiago": "(GMT-04:00) Santiago",
  "America/La_Paz": "(GMT-04:00) La Paz",
  "America/St_Johns": "(GMT-03:30) Newfoundland",
  "America/Argentina/Buenos_Aires": "(GMT-03:00) Georgetown",
  "America/Sao_Paulo": "(GMT-03:00) Brasilia",
  "America/Godthab": "(GMT-03:00) Greenland",
  "America/Montevideo": "(GMT-03:00) Montevideo",
  "Atlantic/South_Georgia": "(GMT-02:00) Mid-Atlantic",
  "Atlantic/Azores": "(GMT-01:00) Azores",
  "Atlantic/Cape_Verde": "(GMT-01:00) Cape Verde Is.",
  "Europe/Dublin": "(GMT) Dublin",
  "Europe/Lisbon": "(GMT) Lisbon",
  "Europe/London": "(GMT) London",
  "Africa/Ghana": "(GMT) Ghana",
  "Africa/Monrovia": "(GMT) Monrovia",
  "Atlantic/Reykjavik": "(GMT) Reykjavik",
  "Africa/Casablanca": "(GMT) Casablanca",
  "Europe/Belgrade": "(GMT+01:00) Belgrade",
  "Europe/Bratislava": "(GMT+01:00) Bratislava",
  "Europe/Budapest": "(GMT+01:00) Budapest",
  "Europe/Ljubljana": "(GMT+01:00) Ljubljana",
  "Europe/Prague": "(GMT+01:00) Prague",
  "Europe/Sarajevo": "(GMT+01:00) Sarajevo",
  "Europe/Skopje": "(GMT+01:00) Skopje",
  "Europe/Warsaw": "(GMT+01:00) Warsaw",
  "Europe/Zagreb": "(GMT+01:00) Zagreb",
  "Europe/Brussels": "(GMT+01:00) Brussels",
  "Europe/Copenhagen": "(GMT+01:00) Copenhagen",
  "Europe/Madrid": "(GMT+01:00) Madrid",
  "Europe/Paris": "(GMT+01:00) Paris",
  "Africa/Algiers": "(GMT+01:00) West Central Africa",
  "Africa/Kinshasa": "(GMT+01:00) Central Africa",
  "Africa/Tunis": "(GMT+01:00) Tunis",
  "Europe/Amsterdam": "(GMT+01:00) Amsterdam",
  "Europe/Berlin": "(GMT+01:00) Berlin",
  "Europe/Rome": "(GMT+01:00) Rome",
  "Europe/Stockholm": "(GMT+01:00) Stockholm",
  "Europe/Vienna": "(GMT+01:00) Vienna",
  "Europe/Minsk": "(GMT+02:00) Minsk",
  "Africa/Cairo": "(GMT+02:00) Cairo",
  "Africa/Johannesburg": "(GMT+02:00) Johannesburg",
  "Europe/Helsinki": "(GMT+02:00) Helsinki",
  "Europe/Riga": "(GMT+02:00) Riga",
  "Europe/Sofia": "(GMT+02:00) Sofia",
  "Europe/Tallinn": "(GMT+02:00) Tallinn",
  "Europe/Vilnius": "(GMT+02:00) Vilnius",
  "Europe/Athens": "(GMT+02:00) Athens",
  "Europe/Bucharest": "(GMT+02:00) Bucharest",
  "Europe/Istanbul": "(GMT+03:00) Istanbul",
  "Asia/Jerusalem": "(GMT+02:00) Jerusalem",
  "Asia/Amman": "(GMT+03:00) Amman",
  "Asia/Beirut": "(GMT+02:00) Beirut",
  "Africa/Windhoek": "(GMT+02:00) Windhoek",
  "Africa/Harare": "(GMT+02:00) Harare",
  "Asia/Kuwait": "(GMT+03:00) Kuwait",
  "Asia/Riyadh": "(GMT+03:00) Riyadh",
  "Asia/Baghdad": "(GMT+03:00) Baghdad",
  "Africa/Nairobi": "(GMT+03:00) Nairobi",
  "Asia/Tbilisi": "(GMT+03:00) Tbilisi",
  "Europe/Moscow": "(GMT+03:00) Moscow",
  "Europe/Volgograd": "(GMT+03:00) Volgograd",
  "Asia/Tehran": "(GMT+03:30) Tehran",
  "Asia/Dubai": "(GMT+04:00) Dubai",
  "Asia/Muscat": "(GMT+04:00) Muscat",
  "Asia/Baku": "(GMT+04:00) Baku",
  "Asia/Yerevan": "(GMT+04:00) Yerevan",
  "Asia/Kabul": "(GMT+04:30) Kabul",
  "Asia/Yekaterinburg": "(GMT+05:00) Ekaterinburg",
  "Asia/Karachi": "(GMT+05:00) Karachi",
  "Asia/Tashkent": "(GMT+05:00) Tashkent",
  "Asia/Kolkata": "(GMT+05:30) Calcutta",
  "Asia/Colombo": "(GMT+05:30) Sri Jayawardenepura",
  "Asia/Katmandu": "(GMT+05:45) Kathmandu",
  "Asia/Dhaka": "(GMT+06:00) Dhaka",
  "Asia/Almaty": "(GMT+06:00) Almaty",
  "Asia/Novosibirsk": "(GMT+06:00) Novosibirsk",
  "Asia/Rangoon": "(GMT+06:30) Yangon (Rangoon)",
  "Asia/Krasnoyarsk": "(GMT+07:00) Krasnoyarsk",
  "Asia/Bangkok": "(GMT+07:00) Bangkok",
  "Asia/Jakarta": "(GMT+07:00) Jakarta",
  "Asia/Brunei": "(GMT+08:00) Beijing",
  "Asia/Chongqing": "(GMT+08:00) Chongqing",
  "Asia/Hong_Kong": "(GMT+08:00) Hong Kong",
  "Asia/Urumqi": "(GMT+08:00) Urumqi",
  "Asia/Irkutsk": "(GMT+08:00) Irkutsk",
  "Asia/Ulaanbaatar": "(GMT+08:00) Ulaan Bataar",
  "Asia/Kuala_Lumpur": "(GMT+08:00) Kuala Lumpur",
  "Asia/Singapore": "(GMT+08:00) Singapore",
  "Asia/Taipei": "(GMT+08:00) Taipei",
  "Australia/Perth": "(GMT+08:00) Perth",
  "Asia/Seoul": "(GMT+09:00) Seoul",
  "Asia/Tokyo": "(GMT+09:00) Tokyo",
  "Asia/Yakutsk": "(GMT+09:00) Yakutsk",
  "Australia/Darwin": "(GMT+09:30) Darwin",
  "Australia/Adelaide": "(GMT+09:30) Adelaide",
  "Australia/Canberra": "(GMT+10:00) Canberra",
  "Australia/Melbourne": "(GMT+10:00) Melbourne",
  "Australia/Sydney": "(GMT+10:00) Sydney",
  "Australia/Brisbane": "(GMT+10:00) Brisbane",
  "Australia/Hobart": "(GMT+10:00) Hobart",
  "Asia/Vladivostok": "(GMT+10:00) Vladivostok",
  "Pacific/Guam": "(GMT+10:00) Guam",
  "Pacific/Port_Moresby": "(GMT+10:00) Port Moresby",
  "Asia/Magadan": "(GMT+11:00) Magadan",
  "Pacific/Fiji": "(GMT+12:00) Fiji",
  "Asia/Kamchatka": "(GMT+12:00) Kamchatka",
  "Pacific/Auckland": "(GMT+12:00) Auckland",
  "Pacific/Tongatapu": "(GMT+13:00) Nukualofa",
};
